import {readGridDensity} from '../shared/components/grid-density-control/grid-density-control.component';
import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, from, Subscription, Subject} from "rxjs";
import { debounceTime, delay, map, filter } from 'rxjs/operators';

 import {StreamsService}  from "../shared/services/streams.service";
import {StreamProject} from "../shared/interfaces";
 import * as moment from 'moment';
import { Socket } from 'ngx-socket-io';
import {SocketVideosOverview, socketEvents} from '../shared/services/sockets';
import { NbDialogService,NbGlobalPosition, NbToastrService } from '@nebular/theme';
 import { NbMenuService } from '@nebular/theme';
  import { GoogleAnalyticsService } from '../@core/utils/analytics.service';


@Component({
  selector: 'app-overview-video-page', 
  templateUrl: './overview-video-page.component.html',
  styleUrls: ['./overview-video-page.component.scss'],
  
})
export class OverviewVideoPageComponent implements OnInit, OnDestroy, AfterViewInit{

  // Cards per row, as a ceiling - the grid drops a column by itself rather than
  // squeezing cards below a readable width.
  colsKey: string = 'livestream:videos:cols'
  cols: number = readGridDensity(this.colsKey)

 
  

  isRoot: boolean = true;
  @ViewChild('deleteModal') deleteModal: any;
   
  pending = false;
  createSub$: Subscription; 
  removeSub$: Subscription;
   fetchLoading: boolean = true;
  videos$: Subscription;
  timeNow: any = moment().unix();
  thumbsTimer: any = null
  showControls: boolean = false
  videoToDelete: StreamProject = null
  removeLoading:boolean = false
  watchersChanged$: Subject<any> = new Subject();
 watchersChangedFn: any
     menuSub$:any;
 
  videos: StreamProject[] 

  constructor(  private streamsService: StreamsService,  
    private socket: SocketVideosOverview,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
private nbMenuService: NbMenuService,
public gAnalytics: GoogleAnalyticsService,
    ){
      //this.socket.removeAllListeners()
     // this.socket.disconnect() 
  }
   

  ngOnInit() { 
  this.videos$ = this.streamsService.fetchStaticVideos().subscribe((videos: StreamProject[])=>{

    let ids = []
      this.videos = videos.map(s =>{
        s.isRunning = false
        ids.push(s.publicIdentity)
        return s
      })


      this.socket.on('connect', ()=>{
        this.socket.emit('onJoin', {
          ids
        })
       this.fetchLoading = false
      })

      this.socket.on(socketEvents.overviewInitialRunings, this.overviewInitialRunings.bind(this))
      this.socket.on(socketEvents.overviewChangeRunings, this.overviewChangeRunings.bind(this))

	this.socket.on('thumbLoaded', (data )=>{

		let video = this.videos.find(vid => ""+vid._id === ""+data.id)
		if(video){
		 video.coverImage =  data.coverImage
		 video.thumbImage =  data.thumbImage
		}

	})
      //initialWatchers
 
      this.socket.on('initialWatchers', this.onInitialWatchers.bind(this))
      this.socket.on('watchersChanged', this.onWatchersChanged.bind(this))
      this.socket.on('videoInfoChanged', this.videoInfoChanged.bind(this))
      
      this.socket.connect()


      //
     },()=>{
      this.fetchLoading = false
      this.toastrService.show(``,'Сталася помилка завантаження',{
        status: 'danger',
        position: <NbGlobalPosition>'bottom-end'
      })
    })   


	

 		if(this.menuSub$){
	      this.menuSub$.unsubscribe()
	   	 }
		this.menuSub$ =	  this.nbMenuService.onItemClick()
		      .pipe(
 			filter(({ tag }) => tag === 'video-menu'),
			 map(({ item }) => item)
		      )
		      .subscribe( (item : any) => {this.onMenuClick(item.cmd, item.item);  }); 

	this.watchersChangedFn = this.watchersChanged.bind(this)

	 this.watchersChanged$
      .pipe(debounceTime(1000))

      .subscribe(this.watchersChangedFn);
  }





   onMenuClick(cmd, video){ 
	if(cmd === 'remove') { this.videoToDelete = video; this.openRemoveModal();   return;}



  }


  openRemoveModal() {
    
    this.dialogService.open(this.deleteModal,{hasScroll: true} )
  
    
  }
  
  



  removeSelectedStream(ref){
    ref.close()
    this.removeStream(this.videoToDelete)

  }



	videoInfoChanged({videoId, data}){
		console.log(videoId, data)
		const vid = this.videos.find(v=>v._id === videoId)

		if(vid){

			vid.staticVideoInfo = {...vid.staticVideoInfo, ...data}
		}
	}



  startThumbsUpdateTimer(){
    
    if(this.thumbsTimer === null){
        this.thumbsTimer = setInterval(()=>{
          this.timeNow =  moment().unix();
      },10000)
    }
  }


  stopThumbsUpdateTimer(){
    if(this.thumbsTimer ){
      clearInterval(this.timeNow)
      this.timeNow = null
    }
  }
  overviewInitialRunings(videos){
    
    var c = 0
    for(let video of videos) {

        const candidate = this.videos.find(s=> ""+s._id == video.id)
          if(candidate) {
          //  console.log(candidate)
          if( video.isRunning){
            c++
          }
            
            candidate.isRunning = video.isRunning
            candidate.hasSignal = true
 
          }

    }

    if(c>0){
      this.startThumbsUpdateTimer()
    }
    
  }


	watchersChanged(data){


	    let video = this.videos.find((s)=>data.publicIdentity === s.publicIdentity)
	   // console.log(data, video)

	      if(video){
		video.watchersCount = data?.watchers ? data.watchers : 0
	      }
  	}

  onWatchersChanged(data){

	this.watchersChanged$.next(data)
 
  }
 

  onInitialWatchers(data){
    this.videos = <StreamProject[]>this.videos.map((s)=>{
 
      let dt = data.find((d)=> {return d.publicIdentity === s.publicIdentity});
      s.watchersCount = dt?.watchers ? dt.watchers : 0

      return s
    }) 
  }

  
  
  overviewChangeRunings(data){
  
      var c = 0
      for(let video of this.videos) {

        if(""+video._id === data.id){
          video.isRunning = data.isRunning
 
        }

        if(video.isRunning){
          c++
        }
      }

      if(c>0){
        this.startThumbsUpdateTimer()
      }else{
        this.stopThumbsUpdateTimer()
      }
      
  }



 
 
  createStream(){

    this.createSub$ = this.streamsService.createStaticVideo().subscribe((video: StreamProject)=>{


      this.toastrService.show(`Відео "${video.title}" створено`,'Додавання відео',{
        status: 'success',
	position: <NbGlobalPosition>'bottom-end'
      })

        video.isRunning = false
        this.videos.unshift(video)

	  this.gAnalytics.trackEvent('Add_video') 
    },()=>{
      
      this.toastrService.show(``,'Сталася помилка',{
        status: 'danger',
        position: <NbGlobalPosition>'bottom-end'
      })
    })

  }

 


  removeStream(video: StreamProject){
    

      if(this.removeSub$){
        this.removeSub$.unsubscribe()
      }

	this.removeLoading = true	

    this.removeSub$ = this.streamsService.delete(video._id).subscribe(()=>{
      this.videoToDelete = null

     this.toastrService.show(`Відео "${video.title}" видалено`,'Видалення відео',{
      status: 'danger',
	position: <NbGlobalPosition>'bottom-end'
    })
      this.videos = this.videos.filter(s => s._id !== video._id)
    },()=>{
	 this.toastrService.show(`Сталася помилка при видаленні`,'Видалення відео',{
      status: 'danger',
	position: <NbGlobalPosition>'bottom-end'
    })
	this.removeLoading = false  
	},()=>{
	

	this.removeLoading = false  
	

	})
  }

  
  ngAfterViewInit() {
    }
 
   ngOnDestroy() {
//     this.modal.destroy()
     if(this.createSub$){
       this.createSub$.unsubscribe()
     }

     if(this.videos$){
      this.videos$.unsubscribe()
    }

    if(this.removeSub$){
      this.removeSub$.unsubscribe()
    }
 

 if(this.menuSub$){
	      this.menuSub$.unsubscribe()
	   	 }
	if(this.watchersChangedFn)
	this.watchersChanged$.unsubscribe()
    this.socket.disconnect()
       //this.socket.removeAllListeners()


 
	this.socket.removeAllListeners('connect')
	this.socket.removeAllListeners(socketEvents.overviewInitialRunings)
	this.socket.removeAllListeners(socketEvents.overviewChangeRunings)
	this.socket.removeAllListeners('initialWatchers')
	this.socket.removeAllListeners('watchersChanged')
	this.socket.removeAllListeners('thumbLoaded')
	this.socket.removeAllListeners('videoInfoChanged') /**/



   }
  
}
